import { Empty, List, Rate, Row, Space, Typography } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import useTranslations from '../../../../hooks/useTranslations';
import { useTherapistCtx } from '../context/TherapistContext';
import { CardStyled } from '../styled/TherapistDetail.styled';
import DynamicIcon from '../../../../components/dynamic-icon';

const { Text } = Typography;

const WrapperRate = styled(Space)`
    gap: 2px !important;
`;

function ReviewsTherapist() {
    const { t } = useTranslations();

    const { isLoading, loadingReviews, dataReviews, reviewsCount, therapist } = useTherapistCtx();

    const textWhatCustomerSaysAbout = t('WhatCustomerSaysAbout', 'What Customer Says About');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
            <CardStyled bodyStyle={{ padding: '0px 12px' }} loading={isLoading}>
                {reviewsCount > 0 ? (
                    <Row style={{ display: 'flex', gap: 16 }} wrap={false} align="middle">
                        <Text strong level={2} style={{ fontSize: 40 }}>
                            {therapist?.rating || 0}
                        </Text>
                        <WrapperRate direction="vertical">
                            <Rate style={{ width: 168 }} disabled allowHalf defaultValue={therapist?.rating || 0} />
                            <Text type="secondary">Based {reviewsCount} customer reviews</Text>
                        </WrapperRate>
                    </Row>
                ) : (
                    <Empty description="No Review" />
                )}
            </CardStyled>
            <CardStyled loading={isLoading || loadingReviews}>
                <Text>{textWhatCustomerSaysAbout}</Text>
                <List
                    dataSource={dataReviews}
                    renderItem={(item) => (
                        <List.Item>
                            <Row
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: 8,
                                    width: '100%',
                                }}
                            >
                                <DynamicIcon iconName="usersound" />
                                <Row align="middle" justify="space-between" style={{ marginBottom: 8 }}>
                                    <Text type="secondary">{moment.unix(item?.mtime).format('MMM DD YYYY')}</Text>
                                    <Rate disabled style={{ width: 168 }} allowHalf defaultValue={item?.rating} />
                                </Row>
                                <Text>{item?.comment}</Text>
                            </Row>
                        </List.Item>
                    )}
                />
            </CardStyled>
        </div>
    );
}

export default ReviewsTherapist;
